import { useCallback, useEffect, useState } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { useAffiliateGoods } from '../queries/useAffiliateGoods';
import { useGoodsDetail } from '../queries/useGoodsDetail';
import { bridge, isNotNil } from 'shared/src/utils';
import { useLogGoodsAnalyticsEvent } from './useLogGoodsAnalyticsEvent';
import { queryKey } from '../constant/queryKey';

export const useAffiliateFloating = () => {
  const queryClient = useQueryClient();

  const { data: affiliateGoods } = useAffiliateGoods();
  const { data: goodsDetail } = useGoodsDetail();
  const logEvent = useLogGoodsAnalyticsEvent();
  const [showFloating, setShowFloating] = useState(false);

  useEffect(() => {
    if (
      isNotNil(affiliateGoods) &&
      affiliateGoods.floating_title &&
      affiliateGoods.floating_title.length > 0 &&
      !queryClient.getQueryData(queryKey.affiliateGoodsFloating())
    ) {
      setShowFloating(true);
    }
  }, [affiliateGoods, queryClient]);

  const onViewFloating = useCallback(() => {
    queryClient.setQueryData(queryKey.affiliateGoodsFloating(), true);
  }, [queryClient]);

  const onClickFloating = useCallback(() => {
    if (!isNotNil(goodsDetail) || !isNotNil(affiliateGoods)) return;

    logEvent({
      name: 'CLICK_FLOATING_BUTTON',
      analytics: affiliateGoods.logging ?? {},
    });

    setShowFloating(false);

    bridge.openGoodsShare({
      is_by_screenshot: false,
      goods_sno: goodsDetail.goods.sno,
      affiliate_reward: {
        expected_reward: affiliateGoods.expected_reward,
        share_nudging: affiliateGoods.share_nudging ?? null,
        logging: affiliateGoods.logging ?? null,
      },
    });
  }, [affiliateGoods, goodsDetail, logEvent]);

  return {
    floatingText: affiliateGoods?.floating_title ?? '',
    showFloating,
    onViewFloating,
    onClickFloating,
  };
};
